import React, { useState, useEffect, Fragment } from "react";
import { useHistory } from "react-router-dom";

import MaterialTable from "material-table";
import {
  makeStyles,
  createStyles,
} from "@material-ui/core/styles";
import validator from 'validator';
import { useTheme } from '@mui/material/styles';
import CloseIcon from "@material-ui/icons/Close";
import { exportMaterialTableToExcel, exportMaterialTableToPDF, getDateString } from "../../utilities/utility";
import { checkUserAccess, getCheckSession } from "../../apis/auth";
import { Backdrop, Box, Button, Checkbox, CircularProgress, createTheme, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, IconButton, Menu, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tabs, TextField, Typography, useMediaQuery } from "@material-ui/core";
import { addUser, getAllDisplayNames, getAllPermissionConfig, getAllUser, addPermissionConfig, updateUser } from "../../query/users.query";
import { TabContext, TabPanel } from "@material-ui/lab";
import { NotificationManager } from "react-notifications";
const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
    },
    table: {
      minWidth: 650,
    },
    root: {
      width: "100%",
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      marginRight: 20,
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(2),
      top: theme.spacing(2),
      color: theme.palette.grey[500],
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    tab: {
      '& .MuiTabPanel-root': {
        padding: '0px',
      },
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      opacity: 0.5,
    },
  })
);

const UserManagement = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [opReportData, setOpReportData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [emailControl, setEmailControl] = useState('');
  const [errorEmail, setErrorEmail] = useState(null);
  const [data, setData] = useState([]);
  const [groupedData, setGroupedData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [value, setValue] = useState("4");
  const [dbList, setDBList] = useState([]);
  const [dbListData, setDBListData] = useState({ db_list: [] });
  const [openDialog, setOpenDialog] = useState(null);
  const [tabKeys, setTabKeys] = useState([]);

  useEffect(async () => {
    console.log("========== LiveMeterFeed : OnInit() ==========");
    var sessionStatus = await getCheckSession();
    if (sessionStatus === false) {
      history.push("/");
      return;
    }
    UpdateSlcTable();
    await getAllPermissionConfig().then((data) => {
      const clonedData = JSON.parse(JSON.stringify(data)); // Creates a deep clone
      const groupKeys = Object.keys(data);
      groupKeys.sort();
      groupKeys.reverse();
      setTabKeys(groupKeys)
      setData(data); // Original reference
      setSelected(clonedData); // New independent copy
    })
  }, []);

  const hideAddUserDialog = () => {
    setErrorEmail('');
    setDBListData({ db_list: [] });
    setEmailControl('')
    setOpenDialog(null)
    setSelectedRow(null);
    setSelectedKeys(initializeSelectedKeys(selected));
    setValue('4');
  }

  const update = () => {
    var selectedAccess = Object.keys(selectedKeys).reduce((acc, key) => {
      acc[`access_${key}`] = selectedKeys[key] && selectedKeys[key].length > 0 ? selectedKeys[key] : [];
      return acc;
    }, {});
    const updateData = {
      user_email: emailControl,
      ...selectedAccess,
      ...(dbListData.db_list.length > 0 ? { db_list: dbListData.db_list } : { db_list: [] })
    };

    updateUser(selectedRow.id, updateData).then((e) => {
      setOpReportData((prev) =>
        prev.map((item) => {
          if (item.user_email === updateData.user_email) {
            return { ...item, ...updateData };
          }
          return item;
        })
      );
      hideAddUserDialog();
      NotificationManager.success("User updated successfully", "", 3000);
    }).catch((e) => {
      alert(e)
      NotificationManager.error("Unable to updated user", "", 3000);
    });
  }

  const add = () => {
    if (!validator.isEmail(emailControl)) {
      setErrorEmail('Valid email is required');
      return;
    }
    var selectedAccess = Object.keys(selectedKeys).reduce((acc, key) => {
      if (selectedKeys[key] && selectedKeys[key].length > 0) {
        acc[`access_${key}`] = selectedKeys[key];
      }
      return acc;
    }, {})
    const updateData = {
      user_email: emailControl.trim(),
      ...selectedAccess,
      ...(dbListData.db_list && dbListData.db_list.length > 0 && { db_list: dbListData.db_list })
    };

    addUser(updateData).then((e) => {
      const data = { id: e, ...updateData };
      setOpReportData((prev) => { return [data, ...prev]; });
      NotificationManager.success("User created successfully", "", 3000);
      hideAddUserDialog();
    }).catch((e) => {
      NotificationManager.error("User email already exists", "", 3000);
    });
  }

  const getOpReportColumnList = () => {
    return [
      {
        title: 'Email',
        field: 'user_email',
        cellStyle: {
          whiteSpace: 'nowrap'
        },
        searchable: true,
        render: ({ user_email: user_email = "" }) => {
          return user_email;
        },
        exportTransformer: ({ user_email: user_email = "" }) => {
          return user_email
        }
      },
      {
        title: 'Access Web',
        cellStyle: {
          minWidth: '350px',
        },
        render: ({ access_web: access_web = [] }) => {
          return access_web.map(item => item || '').join(', ');
        },
        exportTransformer: ({ access_web: access_web = [] }) => {
          return access_web.map(item => item || '').join(', ');
        },
      },
      {
        title: 'Access CMA',
        render: ({ access_cma: access_cma = [] }) => {
          return access_cma.map(item => item || '').join(', ');
        },
        exportTransformer: ({ access_cma: access_cma = [] }) => {
          return access_cma.map(item => item || '').join(', ');
        },
      },
      {
        title: 'Database List',
        cellStyle: {
          minWidth: '300px',
        },
        render: ({ db_list: db_list = [] }) => {
          return db_list.map(item => item || '').join(', ');
        },
        exportTransformer: ({ db_list: db_list = [] }) => {
          return db_list.map(item => item || '').join(', ');
        },
      },
    ];
  };

  async function UpdateSlcTable() {
    await getAllUser().then((data) => { setOpReportData(data); }).catch((e) => { });
    await getAllDisplayNames().then((data) => { setDBList(data); }).catch((e) => { });
  }
  
  const groupDataByGroup = (data) => {
    const groupedData = [];
    for (const [key, items] of Object.entries(data)) {
      groupedData[key] = items.reduce((acc, item) => {
        if (!acc[item.group]) {
          acc[item.group] = [];
        }
        acc[item.group].push(item);
        return acc;
      }, {});
    }
    return groupedData;
  };

  useEffect(() => {
    const groupedData = groupDataByGroup(data);
    setGroupedData(groupedData);
  }, [data]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  
  function initializeSelectedKeys(data) {
    const keys = Object.keys(data);
    const initialState = keys.reduce((acc, key) => {
      acc[key] = []; // Initialize each key with an empty array
      return acc;
    }, {});
    return initialState;
  }
  
  const [selectedKeys, setSelectedKeys] = useState(initializeSelectedKeys(selected));

  const handleItemCheckboxChange = (tabKey, itemKey) => {
    setSelectedKeys(prev => {
      // Ensure prev[tabKey] exists and is an array
      const currentTabKeys = Array.isArray(prev[tabKey]) ? prev[tabKey] : [];
      
      return {
        ...prev,
        [tabKey]: currentTabKeys.includes(itemKey)
          ? currentTabKeys.filter(item => item !== itemKey) 
          : [...currentTabKeys, itemKey]  
      };
    });
  };

  const handleGroupCheckboxChange = (tabKey, groupName) => {
    // Get only the enabled items from this group
    const enabledItemsInGroup = groupedData[tabKey][groupName]
      .filter(item => item.status)
      .map(item => item.key);
    
    setSelectedKeys(prev => {
      // Ensure prev[tabKey] exists and is an array
      const currentTabKeys = Array.isArray(prev[tabKey]) ? prev[tabKey] : [];
      
      // Check if all enabled items are selected
      const allEnabledSelected = enabledItemsInGroup.length > 0 && 
        enabledItemsInGroup.every(item => currentTabKeys.includes(item));
      
      return {
        ...prev,
        [tabKey]: allEnabledSelected
          ? currentTabKeys.filter(item => !enabledItemsInGroup.includes(item)) // Deselect all enabled if all are selected
          : [...currentTabKeys, ...enabledItemsInGroup.filter(item => !currentTabKeys.includes(item))] // Select all enabled if not all are selected
      };
    });
  };

  const handleOverallSelectAll = (tabKey) => { 
    // Get all available items that are enabled (status is true)
    const allEnabledItems = Object.values(groupedData[tabKey] || {}).reduce((acc, group) => { 
      group.filter(item => item.status).forEach(item => { 
        acc.push(item.key); 
      }); 
      return acc; 
    }, []); 
    
    setSelectedKeys(prev => {
      // Ensure prev[tabKey] exists and is an array
      const currentTabKeys = Array.isArray(prev[tabKey]) ? prev[tabKey] : [];
      
      // Check if all enabled items are selected
      const allEnabledSelected = allEnabledItems.length > 0 && 
        allEnabledItems.every(item => currentTabKeys.includes(item));
      
      return {
        ...prev,
        [tabKey]: allEnabledSelected
          ? currentTabKeys.filter(item => !allEnabledItems.includes(item)) // Deselect all enabled if all are selected
          : [...currentTabKeys, ...allEnabledItems.filter(item => !currentTabKeys.includes(item))] // Select all enabled if not all are selected
      };
    });
  };
  
  // Function to check if group has any enabled items
  const hasEnabledItems = (tabKey, groupName) => {
    return groupedData[tabKey] && 
           groupedData[tabKey][groupName] && 
           groupedData[tabKey][groupName].some(item => item.status);
  };

  // Function to check if any group in a tab has enabled items
  const tabHasEnabledItems = (tabKey) => {
    return groupedData[tabKey] && 
           Object.keys(groupedData[tabKey]).some(groupName => 
             hasEnabledItems(tabKey, groupName)
           );
  };
  
  // Function to check if all enabled items in a group are selected
  const areAllEnabledItemsInGroupSelected = (tabKey, groupName) => {
    if (!groupedData[tabKey] || !groupedData[tabKey][groupName]) return false;
    
    const enabledItems = groupedData[tabKey][groupName].filter(item => item.status);
    if (enabledItems.length === 0) return false;
    
    return enabledItems.every(item => 
      Array.isArray(selectedKeys[tabKey]) && selectedKeys[tabKey].includes(item.key)
    );
  };
  
  // Function to check if all enabled items in a tab are selected
  const areAllEnabledItemsInTabSelected = (tabKey) => {
    if (!groupedData[tabKey]) return false;
    
    // Get all enabled items
    const allEnabledItems = Object.values(groupedData[tabKey]).reduce((acc, group) => {
      group.filter(item => item.status).forEach(item => {
        acc.push(item.key);
      });
      return acc;
    }, []);
    
    if (allEnabledItems.length === 0) return false;
    
    return allEnabledItems.every(item => 
      Array.isArray(selectedKeys[tabKey]) && selectedKeys[tabKey].includes(item)
    );
  };

  return (
    <div className="reports">
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        boxSizing: "border-box",
      }}>
        <h2>User List</h2>
        <Button style={{
          backgroundColor: "#0071CE",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
          onClick={() => { setSelectedKeys(initializeSelectedKeys(selected)); setOpenDialog(true); }}
        >
          Add User
        </Button>
      </div>
   
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <div className="dashboard-table">
          <MaterialTable
            style={{
              margin: "20px 0",
              width: "100%",
            }}
            className={classes.table}
            title=""
            columns={getOpReportColumnList()}
            data={opReportData}
 
            actions={[
              {
                icon: 'edit',
                iconProps: { color: 'action' },
                tooltip: 'Edit User',
                onClick: (event, rowData) => {
                  setSelectedRow(rowData);
                  setEmailControl(rowData.user_email);
                  setSelectedKeys(prevState => ({
                    ...prevState, // Keep existing fields
                    ...Object.keys(rowData)
                      .filter(key => key.startsWith('access_'))
                      .reduce((acc, key) => ({
                        ...acc,
                        [key.replace('access_', '')]: Array.isArray(rowData[key]) ? rowData[key] : []
                      }), {})
                  }));
                  setDBListData({ db_list: Array.isArray(rowData.db_list) ? rowData.db_list : [] });
                  setOpenDialog(false);
                }
              },
            ]}
            options={{
              exportButton: true,
              exportAllData: true,
              exportCsv: (columns, csvData) => { exportMaterialTableToExcel(columns, csvData, `Energy Saving Report-${getDateString()}`); },
              exportPdf: (columns, csvData) => { exportMaterialTableToPDF(columns, csvData, `Energy Saving Report-${getDateString()}`, 8, 18); },
              search: true,
              selection: false,
              sorting: true,
              pageSize: 10,
              headerStyle: {
                backgroundColor: "#0071CE",
                color: "#FFF",
                fontSize: "0.9em",
                textAlign: "center",
              },
              actionsColumnIndex: -1,
              emptyRowsWhenPaging: false,
            }}
            localization={{
              toolbar: {
                searchPlaceholder: "Search",
                exportCSVName: "Export as Excel",
                exportPDFName: "Export as PDF",
              },
            }}
          />
        </div>
      </Box>

      <Dialog 
        className="history-dialog" 
        open={selectedRow != null || openDialog} 
        onClose={hideAddUserDialog} 
        aria-labelledby="form-dialog-title" 
        fullScreen={fullScreen} 
        fullWidth 
        maxWidth="lg"
        sx={{
          '& .MuiDialogContainer-root': {
            maxWidth: '80%',
            height: '90vh',
          },
        }}
      >
        <DialogTitle id="editTime-dialog-title" onClose={hideAddUserDialog}>
          {openDialog ? 'New' : 'Update'} User
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={hideAddUserDialog}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {openDialog ? (
            <FormControl className="dialog-form" style={{ width: '100%', margin: '0px 0' }}>
              <TextField
                autoFocus
                margin="dense"
                id="Email"
                label="Email"
                error={!!errorEmail}
                helperText={errorEmail}
                type="text"
                value={emailControl}
                onChange={(e) => { setEmailControl(e.target.value); setErrorEmail('') }}
              />
            </FormControl>
          ) : (
            <>Email : {selectedRow?.user_email}</>
          )}

          <br></br>
          <h3>Permission</h3>

          <TabContext value={value}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                border: "1px solid",
                height: 500,
                borderColor: "hidden",
                borderRadius: 2,
                overflow: 'auto',
                p: 2,
              }}
            >
              <Box sx={{
                borderRight: 1, 
                borderColor: "divider", 
                pr: 1, 
                height: "100%",
                overflowY: "auto",
              }}>
                <Tabs
                  orientation="vertical"
                  variant="scrollable"
                  value={value}
                  onChange={handleChange}
                  TabIndicatorProps={{ style: { backgroundColor: "#2196f3" } }}
                  aria-label="Dynamic Vertical Tabs with Grouped Checkboxes"
                >
                  <Tab value={'4'} label={"Region"} />
                  {tabKeys.map((key, index) => (
                    <Tab key={key} label={key.toUpperCase()} value={index.toString()} />
                  ))}
                </Tabs>
              </Box>
              <Box sx={{
                flexGrow: 1, 
                ml: 2, 
                height: "100%",
                overflowY: 'auto',
              }}>
                {tabKeys.map((key, index) => (
                  <TabPanel key={key} value={index?.toString()}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                      <Box sx={{ flexGrow: 1 }}>
                        {"Select All"}
                      </Box>
                      <FormControlLabel
                        control={
                          <Checkbox
                            // Disable if there are no enabled items in this tab
                            disabled={!tabHasEnabledItems(key)}
                            // Check if all enabled items are selected
                            checked={areAllEnabledItemsInTabSelected(key)}
                            onChange={() => handleOverallSelectAll(key)}
                            color="primary"
                          />
                        }
                        label=''
                      />
                    </Box>

                    {Object.entries(groupedData[key] || {}).map(([groupName, items], groupIndex) => (
                      <Box key={groupIndex} sx={{ mb: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', fontWeight: "bold", mb: 1 }}>
                          <Box sx={{ flexGrow: 1 }}>
                            {groupName.toUpperCase()}
                          </Box>
                          <FormControlLabel
                            control={
                              <Checkbox
                                // Disable if there are no enabled items in this group
                                disabled={!hasEnabledItems(key, groupName)}
                                // Check if all enabled items are selected
                                checked={areAllEnabledItemsInGroupSelected(key, groupName)}
                                onChange={() => { handleGroupCheckboxChange(key, groupName) }}
                                color="primary"
                              />
                            }
                            label=''
                          />
                        </Box>
                        <div style={{ height: '0.3px', backgroundColor: '#ccc', width: '100%' }} />
                        {items.map((item, itemIndex) => (
                          <React.Fragment key={itemIndex}>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                                <span>
                                  {item.name ? item.name.charAt(0).toUpperCase() + item.name.slice(1) : 'Unnamed'}
                                </span>
                                <span style={{ margin: '0 15px' }}>:</span>
                                <span
                                  style={{
                                    fontStyle: 'italic',
                                    color: '#888',
                                  }}
                                >
                                  ( {item.description || 'No description available'} )
                                </span>
                              </Box>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled={!item.status}
                                    checked={Array.isArray(selectedKeys[key]) && selectedKeys[key].includes(item.key)}
                                    onChange={() => {
                                      handleItemCheckboxChange(key, item.key);
                                    }}
                                    color="primary"
                                  />
                                }
                                label=""
                              />
                            </Box>
                            <div style={{ height: '0.3px', backgroundColor: '#ccc', width: '100%' }} />
                          </React.Fragment>
                        ))}
                      </Box>
                    ))}
                  </TabPanel>
                ))}

                {value === '4' && (
                  <Box sx={{ flexGrow: 1, ml: 2 }}>
                    <Box sx={{ mb: 3 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', fontWeight: 'bold', mb: 1 }}>
                        <Box sx={{ flexGrow: 1 }}>
                          {"ALL REGION"}
                        </Box>
                        <FormControlLabel
                          control={
                            <Checkbox
                              disabled={dbList.length === 0}
                              checked={dbList.length > 0 && dbList.every(item => dbListData.db_list.includes(item))}
                              onChange={() => {
                                const allSelected = dbList.every(item => dbListData.db_list.includes(item));
                                const updatedSelection = allSelected
                                  ? [] // Deselect all if all are selected
                                  : dbList; // Select all if any are not selected
                                setDBListData(prevState => ({ ...prevState, db_list: updatedSelection }));
                              }}
                              color="primary"
                            />
                          }
                          label=""
                        />
                      </Box>
                      {dbList.map((item, index) => (
                        <React.Fragment key={index}>
                          <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                            <Box sx={{ flexGrow: 1 }}>
                              <strong>{`${index + 1} : `}</strong> {item.charAt(0).toUpperCase() + item.slice(1) || item}
                            </Box>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={Array.isArray(dbListData.db_list) && dbListData.db_list.includes(item)}
                                  onChange={() => {
                                    setDBListData((prev) => ({
                                      ...prev,
                                      db_list: Array.isArray(prev.db_list) ? 
                                        (prev.db_list.includes(item)
                                          ? prev.db_list.filter((key) => key !== item) // Remove item if selected
                                          : [...prev.db_list, item]) // Add item if not selected
                                        : [item] // If db_list is not an array, initialize with this item
                                    }));
                                  }}
                                  color="primary"
                                />
                              }
                              label=""
                            />
                          </Box>
                          <div style={{ height: '0.3px', backgroundColor: '#ccc', width: '100%' }} />
                        </React.Fragment>
                      ))}
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          </TabContext>
        </DialogContent>
        <DialogActions>
          <Button onClick={hideAddUserDialog}>
            Cancel
          </Button>
          <Button onClick={() => { openDialog ? add() : update() }} type="submit">
            {openDialog ? "Create" : "Update"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default UserManagement;